import { CASE_001 } from '../case/case001';

export const REVEAL_DURATION_MS = CASE_001.timeline.reduce(
  (total, beat) => total + beat.durationMs,
  0,
);

export function getRevealMoment(elapsedMs: number) {
  const bounded = Math.max(0, Math.min(elapsedMs, REVEAL_DURATION_MS));
  let cursor = 0;

  for (let index = 0; index < CASE_001.timeline.length; index += 1) {
    const beat = CASE_001.timeline[index];
    if (bounded <= cursor + beat.durationMs || index === CASE_001.timeline.length - 1) {
      return {
        beat,
        index,
        progress: Math.max(0, Math.min(1, (bounded - cursor) / beat.durationMs)),
      };
    }
    cursor += beat.durationMs;
  }

  return { beat: CASE_001.timeline[0], index: 0, progress: 0 };
}
